import React from "react";
import Config from "../Config";

import "../../assets/scss/SideBar.scss";
import { Popup } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

const triggerId = "toggle-studio-apps-button";

export const StudioAppsButton = () => {
  return (
    <Popup
      basic
      on="click"
      size="small"
      position="bottom center"
      trigger={
        <button className="top-bar_toggle-btn" id={triggerId}>
          <GridIcon width={24} height={24} />
        </button>
      }
      content={<OtherApps />}
      style={{
        padding: "0px",
        border: "none",
        borderRadius: "1rem",
        overflow: "hidden",
        margin: 8,
        zIndex: 3000,
      }}
    />
  );
};

function OtherApps() {
  const [t] = useTranslation();

  return (
    <div
      style={{
        background: "#fafafa",
        width: "340px",
        padding: "0.5rem",
        maxWidth: "100vw",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "0.5rem",
          maxHeight: "min(90vh, 500px)",
          borderRadius: "1rem",
          overflow: "auto",
        }}
      >
        <Links />
      </div>
    </div>
  );
}

function Links() {
  const [t] = useTranslation();
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
      }}
    >
      <LinkItem
        href="/"
        icon={<TransIcon width={48} height={48} color="#FF6D00" />}
      >
        {t("app_name")}
      </LinkItem>
      <LinkItem
        href={Config.artStudioSongUrl}
        icon={<MusicIcon width={48} height={48} color="#003DB3" />}
      >
        {t("studio_music")}
      </LinkItem>
      <LinkItem
        href={Config.studioAvatarUrl}
        icon={<AvatarIcon width={48} height={48} color="#34cD17" />}
      >
        {t("studio_avatar")}
      </LinkItem>
      <LinkItem
        href={Config.studioVideoUrl}
        icon={<VideoIcon width={48} height={48} color="#eebb00" />}
      >
        {t("studio_video")}
      </LinkItem>
      <LinkItem
        href="https://tts.yating.tw/"
        icon={<TTSIcon width={48} height={48} color="#eebb00" />}
      >
        {t("yating_tts")}
      </LinkItem>
    </div>
  );
}

function LinkItem(
  props: React.PropsWithChildren<{
    href: string;
    icon: React.ReactNode;
  }>,
) {
  return (
    <a className="top-bar_apps-container_link-item" href={props.href}>
      {props.icon}
      <span>{props.children}</span>
    </a>
  );
}

const GridIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx={12} cy={5} r={1} />
    <circle cx={19} cy={5} r={1} />
    <circle cx={5} cy={5} r={1} />
    <circle cx={12} cy={12} r={1} />
    <circle cx={19} cy={12} r={1} />
    <circle cx={5} cy={12} r={1} />
    <circle cx={12} cy={19} r={1} />
    <circle cx={19} cy={19} r={1} />
    <circle cx={5} cy={19} r={1} />
  </svg>
);

const TransIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.1902 4.57075C23.4198 5.47645 24.324 6.74302 24.7574 8.16686C25.6503 10.7634 23.8594 13.0831 23.7843 13.1799L21.4115 16.2533L17.4101 21.4369C17.2499 21.6562 17.0466 21.8414 16.8109 21.9823C13.4701 24.4712 8.84015 26.0946 8.59643 26.1801L8.59289 26.1813C8.27651 26.2901 7.91763 26.2428 7.62575 26.054L7.61271 26.0455C7.32148 25.8557 7.13233 25.547 7.10297 25.2138C7.08478 25.0063 6.67657 20.0844 7.59718 15.9988C7.63013 15.7262 7.71653 15.4651 7.85174 15.2296L10.9594 9.46562L12.7981 6.05558C12.8561 5.94571 14.2509 3.35982 16.9852 3.11987C18.4626 2.93611 19.988 3.24671 21.316 4.00172L21.3246 4.00731C21.4386 4.06681 21.5481 4.12242 21.6505 4.17152C21.6954 4.19314 21.7389 4.21764 21.7807 4.24485C21.8223 4.27188 21.8621 4.30148 21.8999 4.33345C21.9888 4.40894 22.0864 4.48754 22.1902 4.57075ZM17.8084 11.8784C17.8331 11.9825 17.8996 12.0768 17.993 12.1403C18.8794 12.6838 19.9358 12.9676 20.9311 13.1602C21.1694 13.2064 21.4046 13.2372 21.6258 13.2628L21.4792 13.4512L21.4789 13.4517C21.3578 13.6073 21.2624 13.73 21.1117 13.9234C20.4062 14.8284 17.2381 13.6382 16.1942 12.9225C14.7998 11.9667 12.7024 9.92116 13.2826 8.83574L13.6767 8.09779C13.7903 8.28904 13.9147 8.49237 14.0526 8.6913C14.6312 9.52024 15.3191 10.3734 16.1776 10.9614C16.2735 11.0209 16.3867 11.0432 16.4918 11.0235C16.5969 11.0037 16.6851 10.9434 16.7367 10.8562C16.8548 10.6798 16.798 10.4316 16.6075 10.2917C15.853 9.71812 15.2044 9.02397 14.6953 8.24538C14.5355 8.01932 14.3985 7.78967 14.2756 7.57638L14.1459 7.34418C14.1245 7.30551 14.1231 7.26113 14.1422 7.22512L14.3343 6.86593C14.4291 6.6883 14.5369 6.51813 14.657 6.35655C14.769 6.53815 14.8904 6.72995 15.0251 6.91789C15.6351 7.76912 16.3545 8.64083 17.2429 9.24799C17.3395 9.31031 17.4545 9.3352 17.5621 9.3171C17.6697 9.299 17.7609 9.23941 17.8153 9.15169C17.9324 8.96998 17.8698 8.7177 17.6731 8.57878C16.8917 7.98862 16.2157 7.27707 15.6782 6.47899C15.5801 6.34332 15.4916 6.20438 15.4069 6.07154L15.3846 6.03656L15.2696 5.84996C15.2366 5.79769 15.2434 5.73403 15.286 5.69611C15.5155 5.50494 15.7697 5.34153 16.0436 5.20901C16.6944 6.06249 17.4112 6.92383 18.3073 7.53509C18.4046 7.60047 18.5216 7.62807 18.6318 7.61167C18.7421 7.59527 18.8365 7.53626 18.8937 7.44791C19.0103 7.26098 18.9418 7.00423 18.7386 6.86659C18.1103 6.39523 17.5466 5.84724 17.0641 5.23895L16.9406 5.08159C16.9135 5.04953 16.9034 5.00826 16.9134 4.97119C16.9235 4.93413 16.9525 4.90598 16.9911 4.89589C18.3293 4.62913 19.6477 5.02907 20.8609 5.7417C22.005 6.56077 22.9061 7.60387 23.2073 8.93384C23.2138 8.97316 23.1998 9.01112 23.17 9.03535C23.1402 9.05958 23.0984 9.06698 23.0581 9.05514L22.8647 9.00648C22.1128 8.81256 21.383 8.51992 20.697 8.13727C20.4887 8.00784 20.2266 8.04965 20.1032 8.23198C20.0458 8.31991 20.03 8.42983 20.0596 8.53709C20.0891 8.64435 20.1614 8.73999 20.2603 8.80255C21.183 9.37075 22.2591 9.67792 23.3054 9.92631C23.2956 10.2303 23.2495 10.5289 23.1681 10.8163C23.1507 10.8706 23.0952 10.9026 23.034 10.8937L22.8157 10.8638L22.7764 10.8579C22.6202 10.8346 22.4564 10.8102 22.2919 10.7754C21.3442 10.6085 20.4194 10.2799 19.5627 9.80563C19.3558 9.68247 19.0999 9.7279 18.9815 9.90879C18.9233 9.99404 18.9058 10.1016 18.9329 10.2073C18.96 10.313 19.0295 10.408 19.1257 10.471C20.0742 11.0043 21.1022 11.3707 22.1556 11.551C22.3823 11.5978 22.6067 11.6308 22.8182 11.6593C22.7194 11.8348 22.6077 12.0025 22.4838 12.1614C22.3939 12.2769 22.3445 12.3402 22.2625 12.4452L22.2339 12.4819C22.2087 12.514 22.1675 12.5307 22.1234 12.5268L21.8585 12.5028C21.613 12.4768 21.3483 12.4453 21.0765 12.3911C20.1584 12.2422 19.2607 11.9316 18.4301 11.4753C18.2248 11.3581 17.975 11.407 17.8618 11.5865C17.803 11.6692 17.7838 11.7743 17.8084 11.8784ZM10.468 21.7438C10.8921 22.0198 11.3528 22.2342 11.8348 22.3798C11.9232 22.4049 12.0132 22.4294 12.1064 22.4491C11.9738 22.5102 11.8411 22.5707 11.7081 22.6305C11.4012 22.7659 11.0828 22.9014 10.753 23.0369C10.5377 23.1247 10.3175 23.2129 10.0925 23.3014C9.81735 23.4084 9.52992 23.5151 9.24117 23.621C9.21567 23.2336 9.19974 22.856 9.18511 22.486C9.16824 21.9793 9.15323 21.4726 9.15302 20.9662C9.15381 20.8175 9.15498 20.6688 9.15653 20.5202C9.50301 21.011 9.95043 21.4285 10.468 21.7438ZM12.1312 10.9367C12.5541 12.2646 14.3224 13.7756 15.3452 14.4398C16.696 15.3131 18.226 15.8486 19.7602 15.9852C18.9148 17.0564 18.1574 18.0167 17.3636 19.0232L17.3612 19.0262L16.7627 19.785C16.4843 20.1799 16.0254 20.4251 15.4917 20.4643C14.3895 20.3816 13.0798 19.6438 12.2888 19.13C11.4515 18.5861 10.1254 17.5002 9.66037 16.4249C9.55336 16.1223 9.56744 15.8108 9.6998 15.5523L12.1312 10.9367ZM15.4244 17.863L15.4247 17.8626L15.4241 17.8635L15.4244 17.863ZM15.6482 16.3918C15.7766 16.9001 15.6961 17.4292 15.4244 17.863C14.8282 18.7463 13.5953 18.9583 12.6697 18.3368C11.7256 17.7434 11.4187 16.5302 11.9843 15.6268C12.5802 14.7431 13.8135 14.5308 14.7392 15.1525C15.1928 15.4376 15.5198 15.8834 15.6482 16.3918Z"
      fill="currentColor"
    />
  </svg>
);
const MusicIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6016 24.9075C14.9238 24.9075 15.1963 24.7961 15.419 24.5735C15.6475 24.3508 15.7647 24.0754 15.7705 23.7473L15.8145 17.6038L18.3018 15.2834C18.8408 15.3069 19.3711 15.2073 19.8926 14.9846C20.4199 14.762 20.8975 14.428 21.3252 13.9827L15.7881 8.45435C15.3487 8.88208 15.0147 9.35669 14.7862 9.87817C14.5635 10.3997 14.4697 10.9329 14.5049 11.4778L6.38381 20.1614C6.17287 20.384 6.07033 20.6213 6.07619 20.8733C6.08791 21.1252 6.21096 21.4065 6.44533 21.717L5.17092 23.3079C5.05373 23.4543 5.00393 23.6155 5.02151 23.7913C5.03908 23.9729 5.11526 24.1311 5.25002 24.2659L5.51369 24.5295C5.64846 24.6643 5.80666 24.7405 5.9883 24.7581C6.16994 24.7756 6.33986 24.72 6.49807 24.5911L8.06252 23.3167C8.37307 23.5569 8.65139 23.6799 8.89748 23.6858C9.14944 23.6917 9.38674 23.592 9.6094 23.387L13.4326 19.8186V23.7473C13.4326 24.0754 13.5469 24.3508 13.7754 24.5735C14.0039 24.7961 14.2793 24.9075 14.6016 24.9075ZM16.9483 7.29419L22.4766 12.8313C23.0156 12.3157 23.3877 11.7327 23.5928 11.0823C23.8037 10.426 23.8272 9.76392 23.6631 9.09595C23.5049 8.42212 23.1387 7.79517 22.5645 7.21509C21.9844 6.63501 21.3574 6.26587 20.6836 6.10767C20.0156 5.9436 19.3565 5.96704 18.7061 6.17798C18.0557 6.38306 17.4697 6.75513 16.9483 7.29419Z"
      fill="currentColor"
    />
  </svg>
);

const AvatarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.66327 22.6149C6.77552 22.6149 6.10828 22.3944 5.66158 21.9534C5.22053 21.518 5 20.8649 5 19.9941V9.62935C5 8.7529 5.22053 8.09697 5.66158 7.66158C6.10828 7.22053 6.77552 7 7.66327 7H22.3367C23.2301 7 23.8974 7.22053 24.3384 7.66158C24.7795 8.10263 25 8.75855 25 9.62935V19.9941C25 20.8649 24.7795 21.518 24.3384 21.9534C23.8974 22.3944 23.2301 22.6149 22.3367 22.6149H7.66327ZM9.29177 21.3427H20.7252C20.5669 20.8055 20.3096 20.3107 19.9534 19.8584C19.6028 19.406 19.173 19.0158 18.6641 18.6879C18.1609 18.3543 17.5982 18.097 16.9763 17.916C16.3599 17.7294 15.704 17.6361 15.0085 17.6361C14.313 17.6361 13.6542 17.7294 13.0322 17.916C12.4159 18.097 11.8561 18.3543 11.3528 18.6879C10.8496 19.0158 10.4198 19.406 10.0636 19.8584C9.71303 20.3107 9.45575 20.8055 9.29177 21.3427ZM15.0085 16.2197C15.5513 16.2253 16.0404 16.0896 16.4758 15.8126C16.9169 15.5355 17.2646 15.1566 17.5191 14.676C17.7792 14.1897 17.9092 13.644 17.9092 13.039C17.9092 12.4736 17.7792 11.9562 17.5191 11.4869C17.2646 11.0119 16.9169 10.633 16.4758 10.3503C16.0404 10.0676 15.5513 9.92621 15.0085 9.92621C14.4713 9.92621 13.9822 10.0676 13.5411 10.3503C13.1001 10.633 12.7495 11.0119 12.4894 11.4869C12.2349 11.9562 12.1077 12.4736 12.1077 13.039C12.1134 13.644 12.2434 14.1869 12.4979 14.6675C12.758 15.1425 13.1057 15.5185 13.5411 15.7956C13.9822 16.0727 14.4713 16.214 15.0085 16.2197Z"
      fill="currentColor"
    />
  </svg>
);
const VideoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.45312 18.9141H13.8438C14.6302 18.9141 15.2448 18.6979 15.6875 18.2656C16.1302 17.8333 16.3516 17.224 16.3516 16.4375V8.69531C16.3516 7.91406 16.1432 7.30729 15.7266 6.875C15.3099 6.44271 14.7083 6.22656 13.9219 6.22656H5.45312C4.70312 6.22656 4.09635 6.44271 3.63281 6.875C3.17448 7.30729 2.94531 7.91406 2.94531 8.69531V16.4375C2.94531 17.224 3.16667 17.8333 3.60938 18.2656C4.05208 18.6979 4.66667 18.9141 5.45312 18.9141ZM17.4141 14.875L20.2578 17.3359C20.3932 17.4505 20.5339 17.5443 20.6797 17.6172C20.8307 17.6849 20.9766 17.7188 21.1172 17.7188C21.4193 17.7188 21.6615 17.6198 21.8438 17.4219C22.0312 17.2188 22.125 16.9557 22.125 16.6328V8.50781C22.125 8.1849 22.0312 7.92448 21.8438 7.72656C21.6615 7.52344 21.4193 7.42188 21.1172 7.42188C20.9766 7.42188 20.8307 7.45573 20.6797 7.52344C20.5339 7.59115 20.3932 7.6849 20.2578 7.80469L17.4141 10.2578V14.875Z"
      fill="currentColor"
    />
  </svg>
);

const TTSIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1em"
    viewBox="0 -960 960 960"
    width="1em"
    fill="currentColor"
    {...props}
  >
    <path d="M160-80q-33 0-56.5-23.5T80-160v-640q0-33 23.5-56.5T160-880h240q17 0 28.5 11.5T440-840q0 17-11.5 28.5T400-800H160v640h440v-40q0-17 11.5-28.5T640-240q17 0 28.5 11.5T680-200v40q0 33-23.5 56.5T600-80H160Zm120-160q-17 0-28.5-11.5T240-280q0-17 11.5-28.5T280-320h200q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240H280Zm0-120q-17 0-28.5-11.5T240-400q0-17 11.5-28.5T280-440h120q17 0 28.5 11.5T440-400q0 17-11.5 28.5T400-360H280Zm100-160q-25 0-42.5-17.5T320-580v-80q0-25 17.5-42.5T380-720h60l92-92q5-5 12.5-8.5T560-824q17 0 28.5 12t11.5 29v326q0 17-11.5 29T560-416q-8 0-15.5-3.5T532-428l-92-92h-60Zm380-100q0 33-13 63t-37 53q-8 8-19 3t-11-18v-202q0-12 11-17.5t19 2.5q24 23 37 53t13 63Zm80 0q0-66-33.5-122T715-830q-15-8-21-23.5t0-30.5q6-16 21.5-22.5T745-905q81 42 128 118t47 167q0 91-47 167T745-335q-14 8-29.5 1.5T694-356q-6-15 0-30.5t21-23.5q58-32 91.5-88T840-620Z" />
  </svg>
);
